import { decodeOneOf, encodeOneOf, METRIC_CODES, safeId } from '../../../../domain';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
import { periodRange } from '../../../../components/period';
import { DASHBOARD_PERIOD_CODES } from './dashboard.periods';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'db';
/** Os parametros deste place: vao para o endereco. */
const P = {
    // Cada um destes era um `useState` no componente antigo, perdido a cada F5.
    DashboardCompany: `${PREFIX}a`,
    /**
     * O ATALHO de periodo do painel. Ver `DASHBOARD_PERIOD_CODES`.
     *
     * Antes guardava um `PeriodType` (dia, semana, mes) e o par `Date` era a ancora
     * da janela. Desde que o painel aceita intervalo, o atalho e um dos do
     * vocabulario compartilhado e as duas pontas moram em `DashboardFrom`/`To`.
     */
    Period: `${PREFIX}b`,
    /** As pontas do intervalo do painel, quando o atalho e "escolher datas". */
    DashboardFrom: `${PREFIX}c`,
    DashboardTo: `${PREFIX}d`,
    /**
     * O indicador do painel inteiro. O `${PREFIX}f` era o das barras, que tinham seletor
     * proprio ate 16/10/2026 (B-37): nao se reaproveita, e link antigo que o traga abre
     * no indicador do grafico.
     */
    Metric: `${PREFIX}e`
};
/**
 * Tudo o que o painel pode estar olhando.
 *
 * Estas cinco propriedades eram cinco `useState` no componente antigo:
 * `selectedCompany`, `selectedPeriod`, `selectedDate`, `selectedMetric` e
 * `selectedBarChartMetric`. Trocar um filtro e recarregar a pagina perdia a
 * escolha, e nao havia como mandar a um colega a tela que se estava vendo.
 *
 * Aqui sao parametros do place. O link carrega, o reload restaura, o Voltar
 * desfaz - e nenhuma linha foi escrita para isso acontecer.
 */
export class DashboardKeys extends RestrictedKeys {
    get place() {
        return Places.dashboard;
    }
    // :: empresa
    /** `undefined` significa todas as empresas, que e o estado inicial. */
    get companyId() {
        return safeId(this._intent.getParameterAsNumber(P.DashboardCompany));
    }
    set companyId(value) {
        this._intent.setParameter(P.DashboardCompany, value);
    }
    // :: periodo
    /**
     * Se o ENDERECO diz um periodo. Quando nao diz, vale o ultimo periodo escolhido no
     * painel (B-35, `recallPeriod`), e nao o padrao fixo desta tela.
     */
    get periodInAddress() {
        return (this._intent.getParameterAsString(P.Period) !== undefined ||
            this._intent.getParameterAsString(P.DashboardFrom) !== undefined ||
            this._intent.getParameterAsString(P.DashboardTo) !== undefined);
    }
    get period() {
        return decodeOneOf(this._intent.getParameterAsString(P.Period), DASHBOARD_PERIOD_CODES, '7d');
    }
    set period(value) {
        // O padrao fica AUSENTE: uma semana deve ter endereco limpo, e o parametro
        // escrito seria ruido que ninguem le.
        this._intent.setParameter(P.Period, value === '7d' ? undefined : encodeOneOf(value, DASHBOARD_PERIOD_CODES));
    }
    // :: intervalo
    /**
     * As pontas do intervalo - lidas do atalho, ou do endereco quando ele e `custom`.
     *
     * So o `custom` as ESCREVE: nos outros o intervalo e derivado do atalho, e
     * repetir na URL o que o atalho ja diz seria ruido - e pior, poderia discordar
     * dele depois que o dia virasse.
     */
    get from() {
        return this._intent.getParameterAsString(P.DashboardFrom) ?? periodRange(this.period).from;
    }
    set from(value) {
        this._intent.setParameter(P.DashboardFrom, this.period === 'custom' ? value : undefined);
    }
    get to() {
        return this._intent.getParameterAsString(P.DashboardTo) ?? periodRange(this.period).to;
    }
    set to(value) {
        this._intent.setParameter(P.DashboardTo, this.period === 'custom' ? value : undefined);
    }
    // :: o indicador do painel
    get metric() {
        return decodeOneOf(this._intent.getParameterAsString(P.Metric), METRIC_CODES, 'FREQUENCIA_CARDIACA');
    }
    set metric(value) {
        this._intent.setParameter(P.Metric, value === 'FREQUENCIA_CARDIACA' ? undefined : encodeOneOf(value, METRIC_CODES));
    }
}
//# sourceMappingURL=dashboard.key.js.map